export default function burgerMenu() {
    $('.burger__js').on("click", function changeBurger() {
        $(this).toggleClass("change");
    })

    const burger = $(".burger__js");
    document.getElementById("mySidenav").style.width = "0";

    //  Open the sidenav
    function openNav(e) {
        if (burger.hasClass("closed")) {
            document.getElementById("mySidenav").style.width = "100%";
            $(".city-name__js").addClass("closed");
            burger.removeClass("closed");
            $(".sidenav-container").addClass("active");
        }
        else {
            document.getElementById("mySidenav").style.width = "0";
            burger.addClass("closed");
            $("body").removeClass("unscrollable");
            $(".sidenav-container").removeClass("active");
        }
    }

    burger.click(openNav)


    $('.handler-dropdown').click(function () {
        if ($(this).children('.handler-dropdown ul').hasClass('active')) {
            $(this).children('.handler-dropdown ul').removeClass('active');
            $(this).removeClass('active');
        }
        else {
            $(this).children('.handler-dropdown ul').addClass("active");
            $(this).addClass('active');
        }
    });

    jQuery(function($){
        $(document).mouseup(function (e){
            var div = $("#mySidenav");
            if (!div.is(e.target) && div.has(e.target).length === 0 && $(e.target).closest('.header_bottom-content').length == 0
            && $(".burger__js").hasClass("change")) {
                $(".sidenav-container").removeClass("active");
                $('.burger__js').click();
            }
            else{
                return;
            }
        });
    });

};





